<template>
  <Modal appear variant="info" @close="close" class="c-modal--delete-project">
    <template slot="lead">
      <span class="c-text--main">
        「{{ project.name }}」のサイトを削除します
      </span>
    </template>
    <template slot="content">
      <div>
        <h4>
          このサイトで設定したデータ（調査データやタスクデータ等）は <br />
          全て削除されますのでご注意ください
        </h4>
      </div>
    </template>
    <template slot="btns">
      <div class="c-alertPos">
        <Button
          variant="main"
          size="w240"
          fsize="f16"
          :disabled="isDisabled"
          :class="{ 'is-loading': isProcessing }"
          @click="submit"
        >
          はい
        </Button>
        <Alert v-if="request.error" variant="center">
          {{ request.error }}
        </Alert>
      </div>
      <Button
        variant="cancel"
        size="w240"
        fsize="f16"
        :disabled="isDisabled"
        @click="close"
      >
        いいえ
      </Button>
    </template>
  </Modal>
</template>

<script>
import Alert from '@/components/Alert';
import Button from '@/components/Button';
import Modal from '@/components/Modal';
import apiProjects from '@/api/projects';

export default {
  props: {
    project: {
      type: Object,
      required: true
    }
  },
  components: {
    Alert,
    Button,
    Modal
  },
  data() {
    return {
      request: {
        error: ''
      },
      isProcessing: false
    };
  },
  computed: {
    organization() {
      return this.$store.getters['view/organization'];
    },
    isDisabled() {
      return this.isProcessing;
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },
    submit() {
      if (this.isDisabled) {
        return;
      }
      this.isProcessing = true;

      const params = {
        organizationId: this.organization.organizationId
      };

      apiProjects
        .delete(params, this.auth.idToken, this.project.id)
        .then(response => {
          this.isProcessing = false;
          this.$store.dispatch('task/resetDraft', this.project.id);
          this.$store.dispatch(
            'page/resetSiteKeywordAnalysis',
            this.project.id
          );
          this.$emit('delete');
        })
        .catch(error => {
          if (error.response && error.response.data) {
            this.request.error = error.response.data.errors[0].userMessage;
          }
          this.isProcessing = false;
        });
    }
  }
};
</script>
